import * as React from 'react'
import PropTypes from 'prop-types'
import Property from '@engine/property'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import './SearchPropertyList.scss'
import { debounce } from '@engine/utils/jsUtils'
import Autocomplete from '@material-ui/lab/Autocomplete'
import TextField from '@material-ui/core/TextField'
import SearchIcon from '@material-ui/icons/Search'

const styles = {
  root: {
    backgroundColor: 'yellow',
    '&.MuiOutlinedInput-root': {
      borderRadius: '25px'
    }
  },
  searchIconStyle: {
    position: 'absolute',
    left: '11px',
    top: '18px',
    fontSize: '22px'
  }
}

function SearchPropertyList(props) {
  const [propertySearchListName, setPropertySearchListName] = React.useState(null)
  const { classes } = props

  const updateFilterProps = value => {
    setPropertySearchListName(value)
    props.listItemClicked(value)
  }

  const onListNameChangeHandler = text => {
    if (text && text.length > 2) {
      props.getPropertySearchList({ data: text })
    }
  }

  const debouncedChange = debounce(onListNameChangeHandler, 250)

  return <div className="search-list-main">
      <Autocomplete data-testid="property-search-list" options={props.propertySearchListLookup} getOptionLabel={option => option.name} onChange={(e, newValue) => updateFilterProps(newValue)} value={propertySearchListName} renderInput={params => <div className="search-bar">
            {props.isSearchListLoading ? <div className="spinner" /> : <SearchIcon className={classes.searchIconStyle} />}
            <TextField className="search-input-box" variant="outlined" margin="dense" name="propertySearchList" type="text" fullWidth onChange={e => debouncedChange(e.target.value)} onBlur={props.resetListSearchResults} placeholder="Search for a Property Search List" {...params} />
          </div>} />
    </div>
}

SearchPropertyList.propTypes = {
  propertySearchListLookup: PropTypes.array,
  getPropertySearchList: PropTypes.func,
  classes: PropTypes.object,
  name: PropTypes.string,
  listItemClicked: PropTypes.func,
  isSearchListLoading: PropTypes.bool,
  resetListSearchResults: PropTypes.func
}

const mapStateToProps = state => ({
  propertySearchListLookup: Property.selectors.property.propertySearchListLookup(state),
  isSearchListLoading: Property.selectors.property.isSearchListLoading(state)
})

const mapDispatchToProps = {
  getPropertySearchList: Property.actions.getPropertySearchList
}

export default withStyles(styles)(connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchPropertyList))
